import React from 'react';
import {Box} from '@material-ui/core';
import {Button} from '../../../index';
import {useHistory} from 'react-router';
import {generatePath} from 'react-router';
import {useTranslation} from 'react-i18next';
import i18nNamespaces from '../../../../const/i18nNamespaces';
import {QUESTIONNAIRE_PAGE} from '../../../../const/routes';
import useStylesCommon from '../common/AdditionalDetailsCommonStyles';

interface PatientAppointmentSurveyPromptProps {
    appointmentId: string;
    isPrescriptionAppointment?: boolean;
}

const PatientAppointmentSurveyPrompt: React.FC<PatientAppointmentSurveyPromptProps> = ({
    appointmentId,
    isPrescriptionAppointment
}) => {
    const history = useHistory();
    const {t} = useTranslation(i18nNamespaces.APPOINTMENT_DETAILS);
    const classesCommon = useStylesCommon();

    const goToSurvey = () => {
        history.push(
            generatePath(QUESTIONNAIRE_PAGE, {appointmentId}),
            {returnToAppointmentDetails: true}
        );
    };

    return (
        <>
            <h4 className={classesCommon.detailsHeader}>
                {t('fillTheQuestionnaireBeforeAppointment.header')}
            </h4>
            <p>
                {t('fillTheQuestionnaireBeforeAppointment.description')}
            </p>
            {isPrescriptionAppointment && <p>{t('fillTheQuestionnaireBeforeAppointment.prescriptionAppointmentAddition')}</p>}
            <Button
                variant="contained"
                color="secondary"
                onClick={goToSurvey}
                fullWidth
            >
                {t('fillTheQuestionnaireBeforeAppointment.buttonLabel')}
            </Button>
        </>
    );
};

export default PatientAppointmentSurveyPrompt;

